/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Ai_Tools_Packs_VideosInputs */

const en_directory_ai_tools_packs_videos = /** @type {(inputs: Directory_Ai_Tools_Packs_VideosInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`≈ ${i?.count} standard videos`)
};

const zh_directory_ai_tools_packs_videos = /** @type {(inputs: Directory_Ai_Tools_Packs_VideosInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`约 ${i?.count} 条标准视频`)
};

/**
* | output |
* | --- |
* | "≈ {count} standard videos" |
*
* @param {Directory_Ai_Tools_Packs_VideosInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_packs_videos = /** @type {((inputs: Directory_Ai_Tools_Packs_VideosInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Packs_VideosInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_packs_videos(inputs)
	return zh_directory_ai_tools_packs_videos(inputs)
});
export { directory_ai_tools_packs_videos as "directory.ai_tools.packs.videos" }